import { useEffect } from 'react';

const SelectInput = (props: any) => {
    const renderedOptions = props.options?.map((option: any, key: number) => {
        if (props.idValue && props.defaultValue === option.id) {
            return (
                <option key={key} value={props.idValue ? option.id : option.name} selected>
                    {option.name}
                </option>
            );
        } else
            return (
                <option key={key} value={props.idValue ? option.id : option.name}>
                    {option.name}
                </option>
            );
    });

    return (
        <div className={`customInputText-box`} style={{ width: props.width === '100%' ? '100%' : `${props.width}px` }}>
            <p className={`customInputText-title`}>{props.title}</p>
            <select
                className={`customInputText-input ${props.errors[props.name] && 'onError'}`}
                style={{ width: ' 100% ' }}
                {...props.register(props.name, props.constraints)}
                defaultValue={props.defaultValue}
            >
                {!props.idValue && <option value=''></option>}
                {renderedOptions}
            </select>
        </div>
    );
};
export default SelectInput;
